import React, { PropsWithChildren } from 'react'
import { mediaQueryUp } from 'components/utils/breakpoint'
import styled from 'styled-components'
import Group from 'components/utils/Group'

const Header = styled(Group)`
  justify-content: space-between;
  align-items: start;

  ${mediaQueryUp.desktop} {
    grid-column: span 3;
  }
`

type Props = PropsWithChildren<{}>

export default function LesaPurchaseSummaryHeader(props: Props) {
  const { children } = props

  return (
    <Header direction="horizontal" horizontalAlign="space-between" verticalAlign="start">
      {children}
    </Header>
  )
}
